import React from 'react';
import PropTypes from 'prop-types';
import { CButton, CModal, CModalBody } from '@coreui/react-pro';

const PopupContent = ({
     onAccept,
     buttonText,
     showPopup,
     onClose,
     title,
     subTitle,
     className,
     showIconClose,
     buttonColor,
     popupIcon,
     titleColor,
}) => {
     return (
          <CModal alignment="center" visible={showPopup} className={`${className ? className : ''}`} onClose={onClose}>
               {showIconClose && <CButton className="close-modal-button" onClick={onClose}></CButton>}
               {popupIcon && (
                    <div className="modal-header d-flex">
                         <img className="img-add-cart" src={popupIcon} width={43} height={34} alt={`Popup ${title} img`} />
                    </div>
               )}
               <CModalBody className="text-center">
                    <h5 className={`popup-title text-${titleColor}`}>{title}</h5>
                    <div className="popup-description text-dark">
                         {subTitle && <p className="cart-text text-dark text-popup-content" dangerouslySetInnerHTML={{ __html: subTitle }}></p>}
                    </div>
                    <button className={`btn btn-h-50 btn-${buttonColor} btn-border`} type="button" data-dismiss="modal" onClick={onAccept}>
                         {buttonText}
                    </button>
               </CModalBody>
          </CModal>
     );
};

PopupContent.propTypes = {
     showPopup: PropTypes.bool,
     onClose: PropTypes.func,
     onAccept: PropTypes.func,
     className: PropTypes.string,
     showIconClose: PropTypes.bool,
     popupIcon: PropTypes.string,
};
PopupContent.defaultProps = {
     buttonText: 'Go to',
     showIconClose: true,
     buttonColor: 'blue-highlight',
     titleColor: '-blue-dark',
};

export default PopupContent;
